// extracted by mini-css-extract-plugin
export var active = "_dg-2";
export var recordingDot = "_dg-1";
export var recordingIndicator = "_dg-0";